<mat-dialog-content class="mat-typography p-0 pb-10 pt-2 max-w-120 min-w-100">
    <div class="flex">
        <div class="min-h-10 h-10 min-w-10 w-10 rounded-full mr-4 flex items-center justify-center bg-warn-200">
            <mat-icon class="text-warn-500" svgIcon="heroicons_outline:exclamation"></mat-icon>
        </div>
        <div>
            <h3 class="text-xl leading-6 font-medium text-[#1e293b]">{{title}}</h3>
            <p class="text-md leading-normal">{{description}}</p>
            <div><ng-content></ng-content></div>
            <p class="text-red-500 font-medium leading-normal mb-1.5 text-sm" *ngIf="showError && isDisable">{{errorText}}</p>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="pb-0 pr-3 -m-3">
    
    <button mat-button class="min-h-9 max-h-9 min-w-16 rounded-[4px]" tabindex="-1" (click)="closeClick('cancel')" *ngIf="!loading">{{"GENERAL.CANCEL" | translate}}</button>
    <btn-loading type="button" color="warn" btnClass="px-6 ml-3 min-h-9 max-h-9 rounded-[4px] text-custom" [loading]="loading"
    [loadingText]="loadingBtnText" (click)="loading ? '':closeClick('yes')">{{confirmBtnText ?? 'GENERAL.DELETE' | translate}}</btn-loading>
</mat-dialog-actions>